import { pagesRoutes } from '@/shared/constants/routes';
import {
  AuthUnexpectedError,
  EmailNotVerifiedError,
  InvalidCredentialsError,
  TooManyRetriesError,
} from '@/features/auth/shared/api/errors/client-auth-errors';
import { signIn, signOut } from 'next-auth/react';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';

type ErrorThrower = () => never;

const credentialsErrorMap: Record<string, ErrorThrower> = {
  credentials: () => {
    throw new InvalidCredentialsError();
  },
  tooManySignInRequests: () => {
    throw new TooManyRetriesError();
  },
  emailNotVerified: () => {
    throw new EmailNotVerifiedError();
  },
};

export const loginUser = async (
  email: string,
  password: string,
  cartId: string | null,
): Promise<void> => {
  const response = await signIn('password', {
    email,
    password,
    cartId: cartId || undefined,
    redirect: false,
  });

  const { error, code } = response;

  if (!error) {
    emitGTMEvent('USER_LOGIN');
    return;
  }

  if (error === 'CredentialsSignin' && code && credentialsErrorMap[code]) {
    credentialsErrorMap[code]();
  }

  throw new AuthUnexpectedError();
};

export const logoutUser = async (redirectTo: string = pagesRoutes.home.href): Promise<void> => {
  emitGTMEvent('USER_LOGOUT');
  return signOut({ redirectTo });
};
